import {useAppSelector} from '../utilities/hooks';
import {getEnvironment} from '../relay/RelayEnvironment';

const useEnvironment = () => {
    const accessToken = useAppSelector((state) => state.auth.accessToken);

    return getEnvironment(accessToken || '');
};

export default useEnvironment;